export const Steps = {
  CURRENCY_DETAILS: 'CURRENCY_DETAILS',
  BENEFICIARY_DETAILS: 'BENEFICIARY_DETAILS',
  BANK_DETAILS: 'BANK_DETAILS',
  INTERMEDIARY_BANK_DETAILS: 'INTERMEDIARY_BANK_DETAILS',
  CONFIRMATION: 'CONFIRMATION',
  SUCCESS: 'SUCCESS',
} as const

export type Step = (typeof Steps)[keyof typeof Steps]

export type FormFieldLabels = {
  accountNumber: string
  accountNumberPlaceholder: string
  bankCode: string
  bankCodePlaceholder: string
}

export type AddressFields =
  | 'AddressLine1'
  | 'AddressLine2'
  | 'City'
  | 'Region'
  | 'PostCode'
  | 'CountryCode'
  | 'CountryName'

export const AddressTypes = {
  BANK: 'bank',
  BENEFICIARY: 'beneficiary',
  INTERMEDIARY_BANK: 'intermediaryBank',
} as const

export type AddressType = (typeof AddressTypes)[keyof typeof AddressTypes]

export type FieldsFetchedFromIbanValidation = {
  accountNumber?: string
  bankCode?: string
  bankName?: string
  bankAddressLine1?: string
  bankAddressLine2?: string
  bankCity?: string
  bankPostCode?: string
  bankRegion?: string
}
